<template>
  <div class="c-table">
    <table>
      <slot/>
    </table>
  </div>
</template>

<style lang="scss">
  .c-table {
    border: 1px solid $border-color;
    border-radius: $border-radius;
    overflow: clip;

    table {
      width: 100%;
      border-collapse: separate;
    }

    tr:not(:last-of-type) td, th {
      border-bottom: 1px solid $border-color;
    }

    tfoot {
      font-weight: $font-weight-medium;

      td, th {
        border-top: 1px solid $border-color;
      }
    }

    th {
      font-weight: $font-weight-medium;
      color: $title-fg;
    }

    th, td {
      padding: .5rem .25rem;
      vertical-align: middle;

      &:first-child {
        padding-left: .75rem;
      }

      &:last-child {
        padding-right: .75rem;
      }
    }
  }
</style>
